import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "./../node_modules/bulma/css/bulma.css";
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faPortrait,
  faSync,
  faCamera
} from '@fortawesome/free-solid-svg-icons'

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import './registerServiceWorker'

library.add(faCheck);
library.add(faPortrait);
library.add(faSync);
library.add(faCamera);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");